import { Component, OnInit } from '@angular/core'
import { CurrencyService } from './currency.service'
import { CurrencyModel } from './currency.model'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-currency.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './currency.master.component.html',
  styleUrl: './currency.master.component.css',
})
export class CurrencyMasterComponent {
  currencyColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'currencyName',
      displayName: 'Currency Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'currencyRate',
      displayName: 'Currency Rate',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private currencyService: CurrencyService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  openAddUpdateCurrencyDialog(mode: string, currency?: CurrencyModel): void {
    const fields = this.currencyColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: currency || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateCurrency(result)
        } else {
          this.addCurrency(result)
        }
      }
    })
  }

  addCurrency(currency: any): void {
    this.currencyService.addCurrency(currency).subscribe({
      next: () => {
        this.toastr.success('Currency Added Successfully!', 'Success')
        this.masterCommonService.getAllCurrencies()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateCurrency(currency: any): void {
    this.currencyService.updateCurrency(currency).subscribe({
      next: () => {
        this.toastr.success('Currency Updated Successfully!', 'Success')
        this.masterCommonService.getAllCurrencies()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteCurrency(currency: CurrencyModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this currency?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        currency.isDeleted = true
        this.currencyService.deleteCurrency(currency).subscribe({
          next: () => {
            this.masterCommonService.currenciesList = this.masterCommonService.currenciesList.filter(
              (p) => p.id !== currency.id,
            )
            this.toastr.success('Currency Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
